import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './SelectItemContainer.module.css';
const SelectItemContainer = ({ children, title, hideBottomBorder, }) => {
    return (_jsxs("div", Object.assign({ className: hideBottomBorder ? '' : styles.bottomBorder }, { children: [_jsx("span", Object.assign({ className: styles.title }, { children: title }), void 0), _jsx("div", { children: children }, void 0)] }), void 0));
};
export default SelectItemContainer;
